var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.funcView.parts_inventory_list)?_c('div',{staticClass:"part-inventory-bd tb",staticStyle:{"padding":"0"}},[_c('custom-tab',{attrs:{"list":_vm.tabList},model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}}),(_vm.tab === '2')?_c('stock'):_vm._e(),(_vm.tab === '3')?_c('unstock'):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }